import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', function() {
    const chsSection = document.querySelectorAll('.case-highlights-section');

    // Initialize Swipers
    chsSection.forEach((section) => {
        const chsSlider = section.querySelector('.chs-slider');
        new Swiper(chsSlider, {
            slidesPerView: 'auto',
            spaceBetween: 16,
            navigation: {
                nextEl: section.querySelector('.chs-button-next'),
                prevEl: section.querySelector('.chs-button-prev'),
            },
        });
    });
});
